/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-09 10:04:21
 * @LastEditTime: 2019-09-10 15:47:19
 * @LastEditors: Please set LastEditors
 */
import { api } from '../api/api'

/** 获取openid */
const oauthOpenid = params => api('wechat/oauthOpenid', params)



export {
  oauthOpenid
}



// WEBPACK FOOTER //
// ./src/server/account/account.js